export enum NotificationType {
  Info = 'information',
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
}
